/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Option2_TextInputs */

const tr_landing_genius_option2_text = /** @type {(inputs: Landing_Genius_Option2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI, Anthropic, Gemini: ne kullanıyorsanız bağlayın. Anahtar sizde kalır, ShopPanel sadece aracıdır.`)
};

const en_landing_genius_option2_text = /** @type {(inputs: Landing_Genius_Option2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI, Anthropic, Gemini: connect whatever you use. The key stays with you, ShopPanel is only the bridge.`)
};

const de_landing_genius_option2_text = /** @type {(inputs: Landing_Genius_Option2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI, Anthropic, Gemini: Verbinden Sie, was immer Sie nutzen. Der Schlüssel bleibt bei Ihnen, ShopPanel ist nur der Vermittler.`)
};

const ru_landing_genius_option2_text = /** @type {(inputs: Landing_Genius_Option2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI, Anthropic, Gemini: подключайте то, чем пользуетесь. Ключ остается у вас, ShopPanel выступает лишь посредником.`)
};

/**
* | output |
* | --- |
* | "OpenAI, Anthropic, Gemini: connect whatever you use. The key stays with you, ShopPanel is only the bridge." |
*
* @param {Landing_Genius_Option2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_option2_text = /** @type {((inputs?: Landing_Genius_Option2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Option2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_option2_text(inputs)
	if (locale === "de") return de_landing_genius_option2_text(inputs)
	if (locale === "ru") return ru_landing_genius_option2_text(inputs)
	return tr_landing_genius_option2_text(inputs)
});